<template>
  <div class="bg-primary-orange">
    <div class="flex justify-between items-center text-gray-800 z-10 px-6 h-24">
      <h1 class="text-3xl font-heading">Settings</h1>
    </div>
    <div
      class="flex-1 overflow-y-scroll bg-gray-100 pt-6 pb-3 px-3 rounded-t-xl flex flex-col justify-between items-center"
    >
      <button class="py-2 px-3 my-2 bg-white active:bg-gray-300 shadow rounded-lg flex items-center w-full text-lg" @click="logout">
        <svg
          class="stroke-current h-5 w-5 mr-2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
        <span>Log out</span>
      </button>
      <p class="text-sm text-gray-600">Version 0.7.1</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "settings",
  methods: {
    logout: async function() {
      this.$store.dispatch('setLoading', true)
      try {
        await this.AuthService.logout();
        this.$store.dispatch('setLoading', false)
      } catch (error) {
        console.error(error)
      }
    }
  }
};
</script>